import { C_OUTLINE_VARIANT, C_PRIMARY } from "./icon/Colors";
import { Radio as MuiRadio, styled } from "@mui/material";

interface RadioProps {
  active?: boolean;
  onClick?: () => void;
  className?: string;
  "data-test-id"?: string;
  value?: string;
  disabled?: boolean;
}

const Radio = (props: RadioProps) => {
  const { active, onClick, className, ...rest } = props;

  return (
    <div className={className}>
      <SimpleRadio checked={active} onChange={onClick} {...rest} />
    </div>
  );
};

export default Radio;

export const SimpleRadio = styled(MuiRadio)({
  margin: "-9px !important",
  color: C_OUTLINE_VARIANT,
  "& svg": {
    fontSize: "20px",
  },
  "&:hover": {
    backgroundColor: "transparent !important",
    color: C_PRIMARY,
  },
  "&.Mui-checked": {
    color: C_PRIMARY + " !important",
  },
  "&.Mui-disabled": {
    color: C_OUTLINE_VARIANT,
    pointerEvents: "none",
  },
});
